
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/voice/webinar",
      function () {
        return require("private-next-pages/voice/webinar.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/voice/webinar"])
      });
    }
  